import { useEffect, useState } from 'react';
import { animateScroll } from 'react-scroll';
import { UiIcon } from 'znanie-uikit';

import css from './ScrollUpButton.module.scss';

export default function ScrollUpButton() {
  const { scrollToTop } = animateScroll;
  const [render, setRender] = useState<boolean>(false);
  const offsetToRender: number = 300;
  const offsetToRemove: number = 300;

  useEffect(() => {
    const handler = (): void => {
      window.scrollY >= offsetToRender &&
      window.scrollY <=
        document.body.scrollHeight - window.screen.availHeight - offsetToRemove
        ? setRender(true)
        : setRender(false);
    };
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <>
      {render && (
        <div onClick={scrollToTop} className={css.scrollUp}>
          <UiIcon
            width="14px"
            height="12px"
            name="arrow-scroll-up"
            color="#666c77"
          />
        </div>
      )}
    </>
  );
}
